export const columns = [
  {
    title: '编号',
    dataIndex: 'id',
  },
  {
    title: '职称名称',
    dataIndex: 'name',
  },
  {
    title: '创建时间',
    dataIndex: 'create_time',
  },
  {
    title: '状态',
    customRender: (text, record)=>{
      return record.status===0?'禁用':'启用';
    },
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
];

export const formData = [
  {
    name: 'name',
    lable: '职称名称',
    lableCol: 4,
    wrapperCol: 18,
    offset: 0,
    span: 24,
  },
];